import { ReactNode } from "react";

export interface ColumnInterface {
  key: string;
  indicator?: "asc" | "desc";
  header?: string; // column headers can be only strings
  width?: number;
  render: (item: any, column?: ColumnInterface) => JSX.Element | ReactNode;
  search?: (item: any, keyword: string, column: ColumnInterface) => boolean;
}

export type SortFn = (a: any, b: any) => SortResult;

export enum SortResult {
  INCORRECT_ORDER = -1,
  EQUAL = 0,
  CORRECT_ORDER = 1,
}
